const commitPendingFieldEdits = () => {
	const focusedElement = document.activeElement;
	const aFieldIsCurrentlyFocused = (
		focusedElement &&
		focusedElement !== document.body &&
		typeof focusedElement.blur === 'function'
	);
	if (aFieldIsCurrentlyFocused) {
		focusedElement.blur();
	}
};

export default commitPendingFieldEdits;
